import { produce } from 'immer';

import { ProfileResponse } from '../../types/profile';

export const subtractValueFromBalance = (value?: number, cached?: ProfileResponse) => {
	if (!cached || !value) {
		return cached;
	}

	return produce(cached, (draft) => {
		const result = draft.data.result;

		const { giving_balance: current } = result;

		const newBalance = current - value;

		result.giving_balance = newBalance;
	});
};
